import TYPES from '@/modules/shared/types';

// Domain
import { CurrencyRepository } from '../../domain/repository/currency-repository';
import { CurrencyEntity } from '../../domain/entities/currency-entity';
import { HttpConnector } from '@/modules/shared/domain/connectors/http';
import Inject from '@/modules/shared/domain/dependency_injection/inject';
import Injectable from '@/modules/shared/domain/di/injectable';

@Injectable()
export default class CurrencyHttpRepository implements CurrencyRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/catalogs/currency/`;

  get_all(): Promise<Array<CurrencyEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(`${this.endpoint}all/`)
        .then((response) => response.json())
        .then(({ success, message, data }) => {
          if (success) {
            resolve(data);
          } else {
            reject(new Error(message));
          }
        })
        .catch(reject);
    });
  }
}
